import React from 'react';
import { connect } from 'react-redux';
import { CartesianGrid, BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import KnotchGraph from '@bit/knotchinc.web-react-components.graphs.knotch-graph';
import { GraphContainer } from '../styled.js';
import { entityListValidate, xTickFormatter, yTickFormatter, MultiLineCustomTooltip, EntityLegend } from '../GraphHelpers.js';

/* ContentOverTimeBars Component */
const ContentOverTimeBars = (props) => {
  const { data = [], entities, filters } = props;
  const { timeInterval = 'month' } = filters;
  const bars = entities.map((entity) => entity.public_id);

  return (
    <KnotchGraph validate={entityListValidate} {...props}>
      <GraphContainer entityLines={bars}>
        <ResponsiveContainer width="100%" height={320}>
          <BarChart data={data}>
            <XAxis
              dataKey="time"
              tickLine={false}
              tickFormatter={(timestamp) => xTickFormatter(timestamp, timeInterval)}
              axisLine={false}
            />
            <YAxis
              width={50}
              axisLine={false}
              tickFormatter={yTickFormatter}
              tickLine={false}
              allowDecimals={false}
            />
            <Tooltip
              labelFormatter={(timestamp) => xTickFormatter(timestamp, 'full')}
              content={MultiLineCustomTooltip}
              entities={entities}
            />
            {entities.length > 1 ? (
              <Legend
                verticalAlign="top"
                align="right"
                height={36}
                content={<EntityLegend entities={entities} />}
                wrapperStyle={{ top: '-55px' }} // Places the legend outside the main container
              />
            ) : null}
            <CartesianGrid vertical={false} stroke={'#F4F4F4'} />
            {entities.map(({ public_id, name }) => (
              <Bar
                key={public_id}
                dataKey={public_id}
                className={`bar_${public_id}`}
                fill="#2D8BFF"
                barSize={2}
                radius={[50, 50, 50, 50]}
                entityName={name}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </GraphContainer>
    </KnotchGraph>
  );
};

const mapStateToProps = ({ Insights: { metadata, filters } }) => ({
  metadata,
  filters,
});

export default connect(mapStateToProps)(ContentOverTimeBars);
